import React from "react";
import Blog_59 from "../component/Blog_59";

function Blog_59_container() {
  return <Blog_59 />;
}

export default Blog_59_container;
